import React from "react";
import ControlTemplate from "../BaseControls/ControlTemplate";
import { controlPropTypes } from "../formhelpers";
import PropTypes from "prop-types";

export default class Label extends React.Component {
    render() {
        const {choiceKey, value} = this.props;

        let valueStr = "";
        if (Array.isArray(value)) {
            valueStr = ArmusScript["toOptionLabel(Array<String>,String)"](value, choiceKey).join(", ");
        }
        else if (value) {
            valueStr = ArmusScript["toOptionLabel(String,String)"](value, choiceKey);
        }
        return (
            <ControlTemplate {...this.props} className="choice-field" >
                <span>{valueStr}</span>
            </ControlTemplate>
        );
    }
}

Label.propTypes = {
    ...controlPropTypes(),
    choiceKey: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/ChoiceField/label.js